// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import WebauthnAuthenticateController from "./webauthn_authenticate_controller"
application.register("webauthn-authenticate", WebauthnAuthenticateController)

import WebauthnRegisterController from "./webauthn_register_controller"
application.register("webauthn-register", WebauthnRegisterController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import ContactRecaptchaController from "./contact_recaptcha_controller"
application.register("contact-recaptcha", ContactRecaptchaController)
